/**
 * Created by robert.lavoie on 6/12/17.
 */


import { Component, Input } from '@angular/core';

// Models
import { SiteColumn } from 'careerpages-base/models/site-column';
import { AlternateTypeColors } from 'careerpages-base/utils/colorFormat';


/**
 *
 * @class
 * CustomerSiteColumnComponent
 *
 * @description
 * There are 3 column types available which include text, video and image
 *
 */
@Component({
  templateUrl: 'customer-site-column.component.html',
  selector: 'customer-site-column',
  styleUrls: ['./customer-site-column.component.scss'],
})
export class CustomerSiteColumnComponent{

  // Column data
  @Input() column: SiteColumn;

  // Column data
  @Input() theme: object;

  constructor() {}

    /**
  * Creates the background-image style if the current column has a background image
  *
  * @return { Object }
  */
  getColumnBackgroundStyle(column: SiteColumn) {

    // If there is no background image or color then don't add the style
    if (!column.backgroundImage && !column.backgroundColor) {
      return false;
    }

    // Otherwise build the style object and return it
    const style = {};

    if (column.backgroundImage){
      style['background-image'] = `url(${column.backgroundImage.url})`;
      style['background-size'] =  'cover';
      style['background-position'] =  'center center';
    }

    if (column.backgroundColor){
      style['background-color'] = (AlternateTypeColors[column.backgroundColor]) ? AlternateTypeColors[column.backgroundColor] : this.theme[column.backgroundColor];
    }

    return style;
  }

}
